import { render } from "./InvoiceTemplates.vue?vue&type=template&id=9befa576"
import script from "./InvoiceTemplates.vue?vue&type=script&lang=js"
export * from "./InvoiceTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__